import FreeSamplesModal from 'components/GlobalModals/FreeSamplesModal/FreeSamplesModal';
import { withFreeSamplesModalProps } from 'viewModel/globalModals/freeSamplesModal/withFreeSamplesModalProps';
const ConnectedFreeSamplesModalProps = withFreeSamplesModalProps(FreeSamplesModal);

export default ConnectedFreeSamplesModalProps;
